import React from "react";
import loader from "../../src/assets/img/generic/loader.gif";

const FullScreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      <div className="loader">
        <img src={loader} alt="Loading" className="img-fluid" />
      </div>
    </div>
  );
};

export default FullScreenLoader;
